import styled from 'styled-components'
import { colors } from '../utils/config'
import { ChangeEventHandler } from 'react'

const StyledCheckbox = styled.div<{
  $allBlue: boolean
  $hasNoMargin?: boolean
}>`
  .checkbox-label {
    margin: 0;
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.1rem;
    color: ${colors.gray700};
    font-weight: 500;
    display: block;
  }
  .checkbox-description {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
  }
  .checkbox-container {
    position: relative;
    .toggle {
      position: relative;
      display: block;
      width: 40px;
      height: 20px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transform: translate3d(0, 0, 0);
    }
    .toggle:before {
      content: '';
      position: relative;
      top: 3px;
      left: 3px;
      width: 34px;
      height: 14px;
      display: block;
      background: ${({ $allBlue }) =>
        $allBlue ? colors.primary400 : '#9a9999'};
      border-radius: 8px;
      transition: background 0.2s ease;
    }
    .toggle span {
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      display: block;
      background: ${({ $allBlue }) => ($allBlue ? colors.primary300 : 'white')};
      border-radius: 10px;
      box-shadow: 0 3px 8px rgba(154, 153, 153, 0.5);
      transition: all 0.2s ease;
    }
    .toggle span:before {
      content: '';
      position: absolute;
      display: block;
      margin: -18px;
      width: 56px;
      height: 56px;
      background: rgba(79, 46, 220, 0.5);
      border-radius: 50%;
      transform: scale(0);
      opacity: 1;
      pointer-events: none;
    }
    display: flex;
    input {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      pointer-events: none;
    }
    input:checked + .toggle:before {
      background: ${colors.primary400};
    }
    input:checked + .toggle span {
      background: ${colors.primary300};
      transform: translateX(20px);
      transition:
        all 0.2s cubic-bezier(0.8, 0.4, 0.3, 1.25),
        background 0.15s ease;
      box-shadow: 0 3px 8px rgba(79, 46, 220, 0.2);
    }
    input:checked + .toggle span:before {
      transform: scale(1);
      opacity: 0;
      transition: all 0.4s ease;
    }
    p {
      font-size: 1rem !important;
      margin-right: 1rem !important;
      &.second-placeholder {
        margin-right: 0rem !important;
        margin-left: 1rem !important;
      }
    }
    margin-bottom: ${({ $hasNoMargin }) => ($hasNoMargin ? '0' : '1.6rem')};
  }
  &.light {
    .checkbox-label {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
      color: ${colors.gray700};
    }
  }
`

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean
  label?: string
  desc?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  allBlue?: boolean
  required?: boolean
  noMargin?: boolean
  disabled?: boolean
  placeholder?: string
  secondPlaceholder?: string
  light?: boolean
}

const Checkbox = ({
  name,
  checked,
  id,
  label,
  desc,
  onChange,
  allBlue,
  required,
  noMargin,
  placeholder,
  disabled,
  secondPlaceholder,
  light,
}: Props) => {
  return (
    <StyledCheckbox
      $allBlue={!!allBlue}
      $hasNoMargin={noMargin}
      className={light ? 'light' : ''}
    >
      {label && <span className='checkbox-label'>{label}</span>}
      {desc && <span className='checkbox-description'>{desc}</span>}
      <div className={`${disabled ? 'disabled' : ''} checkbox-container`}>
        {placeholder ? <p>{placeholder}</p> : null}

        <input
          type='checkbox'
          name={name}
          id={id || name}
          disabled={disabled}
          checked={checked}
          required={required}
          onChange={onChange}
        />
        <label htmlFor={id || name} className='toggle'>
          <span></span>
        </label>
        {secondPlaceholder ? (
          <p className='second-placeholder'>{secondPlaceholder}</p>
        ) : null}
      </div>
    </StyledCheckbox>
  )
}

export default Checkbox
